import { FormikInput } from "@src/components/forms/FormikInput";
import { FormikPhoneInput } from "@src/components/forms/FormikPhoneInput";
import { FormikStateSelect } from "@src/components/forms/FormikStateSelect";
import { FormikZipInput } from "@src/components/forms/FormikZipInput";
import { HeaderText } from "@src/components/general/HeaderText";
import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/components/layout/Flexbox";
import { useFormikWizard } from "@src/components/layout/Wizard";
import { AccountCreate } from "../CreateAccount.types";

export const PracticeInfoStep = () => {
  useFormikWizard<AccountCreate>({
    formikFields: ["addressLine1", "city", "state", "zip", "phone", "fax"],
  });

  return (
    <VerticalFlexbox gap="md">
      <HeaderText tag="h2" fontWeight={600}>
        Practice Information
      </HeaderText>
      <FormikInput name="addressLine1" label="Address" required />
      <FormikInput name="addressLine2" label="Suite (optional)" />
      <HorizontalFlexbox gap="sm" className="flex-wrap sm:flex-nowrap">
        <FormikInput name="city" label="City" required />
        <FormikStateSelect name="state" label="State" required />
        <FormikZipInput name="zip" label="Zip Code" required />
      </HorizontalFlexbox>
      <FormikPhoneInput name="phone" label="Phone (optional)" />
      <FormikPhoneInput name="fax" label="Fax (optional)" />
    </VerticalFlexbox>
  );
};
